import CarouselItem from './CarouselItem'

export default CarouselItem



// WEBPACK FOOTER //
// ./src/components/CarouselItem/index.js